
export default {
  props: {
    headers: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    firstColumnEmphasized: {
      type: Boolean,
      default: false
    },
    /*
      Renders rows as individual definition lists (2d tables),
      first column acts as table title
    */
    rowsAsListsOnMobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    lists() {
      return this.rows.map(row => ({
        title: row[0],
        items: this.headers
          .map((key, index) => ({
            value: row[index],
            key
          }))
          .filter(item => item.value && item.key)
      }))
    }
  }
}
